const CarouselCard = ({ image, setActivePhoto }) => {
    return (
        <div onClick={() => setActivePhoto(image.src)} className='relative z-0 block w-64 bg-left-top bg-no-repeat bg-cover shadow h-96 snap-center aspect-square' style={{ backgroundImage: `url(${image.src})` }} />
    )
}

export default CarouselCard